const ALPHANUMERIC_CHARACTERS =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

const MAX_VALID_BYTE = 256 - (256 % ALPHANUMERIC_CHARACTERS.length); // keeps selection unbiased

export function generateAlphanumeric(keyLength: number = 16): string {
  if (keyLength <= 0) {
    return '';
  }

  const cryptoImpl = globalThis.crypto;

  if (!cryptoImpl?.getRandomValues) {
    throw new Error(
      'crypto.getRandomValues is not available in this environment.',
    );
  }

  const charactersLength = ALPHANUMERIC_CHARACTERS.length;
  const result: string[] = [];

  while (result.length < keyLength) {
    const randomBytes = cryptoImpl.getRandomValues(new Uint8Array(keyLength));

    for (let i = 0; i < randomBytes.length && result.length < keyLength; i++) {
      const t = randomBytes[i];
      if (t < MAX_VALID_BYTE) {
        result.push(ALPHANUMERIC_CHARACTERS[t % charactersLength]);
      }
    }
  }

  return result.join('');
}
